import {getJson, removeItem, setJson} from './storage';
const USER_KEY = 'user';

export const getIsSuperCompany = (user) => {
    const currentUser = user || getJson(USER_KEY);
    return Boolean(currentUser?.active_super_company);
};

class Auth {
    constructor() {
        this.user = getJson(USER_KEY);
        this.deviceToken = null;
    }

    isAuth() {
        return !!(this.getUser());
    }

    getUser() {
        return this.user;
    }

    getDeviceToken() {
        return this.deviceToken;
    }

    setAuth(data, noLocalStorage = false) {
        this.user = data;
        !noLocalStorage && setJson(USER_KEY, data);
    }

    setDeviceToken(token) {
        this.deviceToken = token;
    }

    logout() {
        this.user = null;
        this.deviceToken = null;

        removeItem(USER_KEY);
    }
}

export default new Auth();
